// 美元金额格式化
export const formatAmount = (value) => {
  const amount = typeof value === "number" ? value : parseFloat(value);
  
  if (typeof amount === "number" && !isNaN(amount)) {
    const formatted = Math.abs(amount).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
 
    return amount < 0 ? `(${formatted})` : formatted;
  }
  return "$0.00";
};
